import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import ConectUs from "../../components/ConectUs";

import BlockLeftImage from "../../components/BlockLeftImage";
import Quote from "../../components/Quote";
import calendario from "../../img/iconsoferta/calendario.png";
import modalidad from "../../img/iconsoferta/modalidad.png";
import titulo from "../../img/iconsoferta/titulo.png";
import sale from "../../img/iconsoferta/sale.png";

import inicio from "../../img/iconsoferta/inicio.png";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import Block5Columns from "../../components/Block5Columns";
import Block3Columns from "../../components/Block3Columns";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockRightImage from "../../components/BlockRightImage";
import EnLineaPagos from "../../components/Enlineapagos";
import AccordionFromHtml from "../../components/Accordionfromhtml";

function CarreraGovTechMetodologia() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div className="margin ">
            <Breadcumbs
              content={
                <>
                  <NavLink to="/carrera-govtech-online">
                    Carrera en GovTech y Administración Pública{" "}
                  </NavLink>
                  <span class="material-icons">chevron_right</span>
                  <NavLink to="/metodologia-govtech">Metodología</NavLink>
                </>
              }
            ></Breadcumbs>

            <div className="  layout8">
              {" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_portada,
                }}
              />
            </div>
            <img src={item.field_portada} alt="utpl"></img>

            <div className="padding lightbluebg">
              <div>
                <div
                  className="layout6"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque5,
                  }}
                />
              </div>
              <Block3Columns
                col1={
                  <>
                    <center>
                      <p className="iconsize20">🖍</p>
                      <h3>Diplomados</h3>
                    </center>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque6,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    <center>
                      <p className="iconsize20">👨‍🎓</p>
                      <h3>Microcredenciales</h3>
                    </center>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque7,
                      }}
                    />
                  </>
                }
                col3={
                  <>
                    <center>
                      <p className="iconsize20">🔏</p>
                      <h3>Certificaciones</h3>
                    </center>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque8,
                      }}
                    />
                  </>
                }
              ></Block3Columns>
            </div>

           

            <BlockRightImage
              src={item.field_imagen1}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                </>
              }
            ></BlockRightImage>
            <BlockLeftImage
              src={item.field_imagen2}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque2,
                    }}
                  />
                </>
              }
            ></BlockLeftImage>

            <BlockRightImage
              src={item.field_imagen3}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                </>
              }
            ></BlockRightImage>
            <BlockLeftImage
              src={item.field_imagen4}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                </>
              }
            >
              {" "}
            </BlockLeftImage>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/metodologia-govtech.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes en línea y a distancia."
        instagram="https://www.instagram.com/utplenlinea/"
        facebook="https://www.facebook.com/utplenlinea/"
        tiktok="https://www.tiktok.com/@utplenlinea"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default CarreraGovTechMetodologia;
